import { isVisitTypeSelectableForHotel } from '../components/VisitTypeCategoriesAccordion/helpers'
import { useBookingFormStore } from '../providers/BookingFormStoreProvider'
import { IHotel } from '../store/data'
import {
  HOTEL_PARAM,
  ROOM_TYPE_PARAM,
  useQueryParams,
  VISIT_END_PARAM,
  VISIT_START_PARAM,
  VISIT_TYPE_PARAM,
} from './useQueryParams'

export const useHotelAccordion = () => {
  const guest = useBookingFormStore((state) => state.guest)
  const language = useBookingFormStore((state) => state.language)
  const roomType = useBookingFormStore((state) => state.roomType)
  const visitType = useBookingFormStore((state) => state.visitType)
  const changeHotel = useBookingFormStore((state) => state.changeHotel)
  const changeRoomType = useBookingFormStore((state) => state.changeRoomType)
  const changeVisitType = useBookingFormStore((state) => state.changeVisitType)
  const changeVisitTypeCategory = useBookingFormStore((state) => state.changeVisitTypeCategory)

  const { addQueryParameter, removeQueryParameter, removeQueryParametersArray } = useQueryParams()

  const updateRouteQuery = async (value: string | undefined) => {
    if (value) {
      await addQueryParameter(HOTEL_PARAM, value)
    } else {
      await removeQueryParameter(HOTEL_PARAM)
    }
  }

  const validateHotelRoomType = async (currentHotelValue: IHotel | null) => {
    if (roomType) {
      // e.g. hotel has been changed, and we have to check if a room type is included and if beds count fits guests number
      const idsRoomTypes = (currentHotelValue?.roomTypes || [])
        .filter((item) => {
          return guest !== null ? item.beds === guest : true
        })
        .map((item) => item.id)

      if (!idsRoomTypes.includes(roomType.id)) {
        changeRoomType(null)

        await removeQueryParametersArray([ROOM_TYPE_PARAM, VISIT_START_PARAM, VISIT_END_PARAM])
      }
    } else {
      await removeQueryParametersArray([ROOM_TYPE_PARAM, VISIT_START_PARAM, VISIT_END_PARAM])
    }
  }

  const validateHotelVisitType = async (selectedHotel: IHotel) => {
    // Check if current visit type is compatible with selected hotel
    if (
      visitType &&
      !isVisitTypeSelectableForHotel(visitType, selectedHotel.id, language)
    ) {
      // Visit type is not compatible with hotel, clear it
      changeVisitType(null)
      changeVisitTypeCategory(null)
      await removeQueryParameter(VISIT_TYPE_PARAM)
    }
  }

  const onChangeHotel = async (value: IHotel | null) => {
    changeHotel(value)

    if (value) {
      // Only validate visit type compatibility, don't automatically clear it
      await validateHotelVisitType(value)
    } else {
      // If hotel is cleared, also clear visit type
      changeVisitType(null)
      changeVisitTypeCategory(null)
      await removeQueryParameter(VISIT_TYPE_PARAM)
    }

    await updateRouteQuery(value?.name)
    await removeQueryParametersArray([
      ROOM_TYPE_PARAM,
      VISIT_START_PARAM,
      VISIT_END_PARAM,
    ])
  }

  const onInitHotelValidation = async (value: IHotel | null) => {
    if (!value) {
      await removeQueryParameter(HOTEL_PARAM)
    }

    await validateHotelRoomType(value)
  }

  return {
    onChangeHotel,
    onInitHotelValidation,
  }
}
